import { useTelegramWebApp } from '@/hooks/useTelegramWebApp'

/**
 * Обёртка над useTelegramWebApp для tg-сборки — вызывает старый хук инициализации,
 * чтобы правила React (условный вызов хуков) не нарушались при разделении на tg/web.
 */
export const useTgBootstrap = () => {
  const { isLoading, startParam } = useTelegramWebApp()
  return { isLoading, startParam }
}
